<template>
  <v-container>
    <ViewsContainer
      :moduleName="moduleName"
      :listViewComponent="Table"
      :filterComponent="Filter"
      :data="data"
      :config="'@/components/modules/clients/contacts/contacts.config'"
      :onCreate="create"
      :onUpdate="update"
      :onDelete="remove"
      :show_toolbar="true"
      :show_pagination="true"
      :title="{singular:'Contacto', plural:'Contactos'}"
      :rowActionHandlers="rowActionHandlers"
      :key="moduleName"
      :client="client"
      :clientId="clientId"
    />
  </v-container>
</template>

<script lang="ts" setup>
import { onMounted, ref, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useContactsStore } from '@/store/contacts';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/clients/contacts/contacts.config';
import { CARD_FIELDS, DEFAULT_CARD_ORDER } from '@/components/modules/sales/sales.config';
import { useDisplay } from 'vuetify';

const { mobile } = useDisplay();
const isMobile = computed(() => mobile.value);

import Table from '@/components/views/TableView.vue';
import MobileCardsView from '@/components/views/MobileCardsView.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue'

const moduleName = 'Contacts';
const preferencesStore = usePreferencesStore();
const contactsStore = useContactsStore();

const props = defineProps<{ clientId: number, client?: any }>();

const { clientId } = props;

const buildParams = (params: any) => {
  // Solo agrega el filtro si clientId está definido y es válido
  if (clientId !== undefined && clientId !== null) {
    return {
      ...params,
      'filter[client_id]': clientId,
    };
  }
  return params;
};

const {
  create,
  update,
  remove,
} = useModuleLayoutFetcher(
  moduleName,
  (params) => contactsStore.fetchContacts(buildParams(params)),
  {
    create: contactsStore.createContact,
    update: (data) => contactsStore.updateContact(data.id, data),
    remove: contactsStore.deleteContact,
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  // Registra los headers y defaults para ESTE módulo:
  preferencesStore.setAllModuleHeaders(moduleName, HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    moduleName,
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find(header => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

const rowActionHandlers = {
  
};

const data = computed(() => contactsStore.contacts);

</script>
